import { Controller } from "@hotwired/stimulus"
import { useTransition } from "stimulus-use"

// Przy pierwszym kliku przycisku pobiera listę szablonów (JSON: tylko id+name) i buduje DOM-em
// linki do dropdownu, dopiero potem pokazuje menu — żeby okienko wysunęło się z gotową treścią.
// Manipulujemy klasą .hidden na menu bezpośrednio (nie korzystamy z dropdown controllera), bo
// programowy click + useTransition powoduje "dwuklik" przy pierwszym otwarciu.
// Animacja przez useTransition + data-transition-* na menu.
export default class extends Controller {
  static targets = ["content", "menu"]
  static values = { url: String, emptyMessage: String }

  connect() {
    useTransition(this, { element: this.menuTarget })
    this.outsideClickHandler = this.handleOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickHandler)
  }

  async open(event) {
    event.preventDefault()
    event.stopPropagation()

    // ignorujemy klik gdy fetch jeszcze trwa — bez tego szybkie podwójne kliknięcie odpaliłoby dwa requesty
    if (this.loading) { return }

    if (this.menuOpen) {
      this.hideMenu()
      return
    }

    if (!this.loaded) {
      this.loading = true
      try {
        const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
        if (!response.ok) { return }
        const items = await response.json()
        this.renderItems(items)
        this.loaded = true
      } catch (error) {
        console.error("chat template list fetch failed", error)
        return
      } finally {
        this.loading = false
      }
    }

    this.showMenu()
  }

  showMenu() {
    this.enter()
    this.menuOpen = true
    // listener dodajemy z opóźnieniem, żeby aktualny event (już propaguje na document) go nie wywołał od razu
    setTimeout(() => document.addEventListener("click", this.outsideClickHandler), 0)
  }

  hideMenu() {
    this.leave()
    this.menuOpen = false
    document.removeEventListener("click", this.outsideClickHandler)
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.hideMenu()
    }
  }

  renderItems(items) {
    this.contentTarget.replaceChildren()
    if (items.length === 0) {
      const span = document.createElement("span")
      span.className = "block text-gray-400 px-4 py-2 text-sm italic"
      span.textContent = this.emptyMessageValue
      this.contentTarget.appendChild(span)
      return
    }
    for (const item of items) {
      const link = document.createElement("a")
      link.href = "#"
      link.dataset.action = "click->chat-template-inserter#insert click->chat-template-loader#hideMenu"
      link.dataset.chatTemplateId = item.id
      link.className = "block break-words text-gray-700 px-4 py-2 text-sm hover:bg-gray-50 truncate"
      link.title = item.name
      link.textContent = item.name
      this.contentTarget.appendChild(link)
    }
  }
}
